/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseNewBlogPostFragment, NewBlogPostFragment, FullNewBlogPostFragment} from '@amblique/contentful/app/contentful/fragments/new-blog-post';

/**
 * Get a single NewBlogPost by ID (base - scalars only)
 */
export const getBaseNewBlogPostById = gql`
  ${BaseNewBlogPostFragment}

  query GetBaseNewBlogPostById($id: String!, $locale: String!, $preview: Boolean) {
    newBlogPost(id: $id, locale: $locale, preview: $preview) {
      ...BaseNewBlogPostFragment
    }
  }
`;

/**
 * Get a single NewBlogPost by ID (standard - 1 level deep)
 */
export const getNewBlogPostById = gql`
  ${NewBlogPostFragment}

  query GetNewBlogPostById($id: String!, $locale: String!, $preview: Boolean) {
    newBlogPost(id: $id, locale: $locale, preview: $preview) {
      ...NewBlogPostFragment
    }
  }
`;

/**
 * Get a single NewBlogPost by ID (full - 2 levels deep)
 */
export const getFullNewBlogPostById = gql`
  ${FullNewBlogPostFragment}

  query GetFullNewBlogPostById($id: String!, $locale: String!, $preview: Boolean) {
    newBlogPost(id: $id, locale: $locale, preview: $preview) {
      ...FullNewBlogPostFragment
    }
  }
`;

/**
 * Get a single NewBlogPost by slug (base - scalars only)
 */
export const getBaseNewBlogPostBySlug = gql`
  ${BaseNewBlogPostFragment}

  query GetBaseNewBlogPostBySlug($slug: String!, $locale: String!, $preview: Boolean) {
    newBlogPostCollection(
      where: { slug: $slug }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...BaseNewBlogPostFragment
      }
    }
  }
`;

/**
 * Get a single NewBlogPost by slug (standard - 1 level deep)
 */
export const getNewBlogPostBySlug = gql`
  ${NewBlogPostFragment}

  query GetNewBlogPostBySlug($slug: String!, $locale: String!, $preview: Boolean) {
    newBlogPostCollection(
      where: { slug: $slug }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...NewBlogPostFragment
      }
    }
  }
`;

/**
 * Get a single NewBlogPost by slug (full - 2 levels deep)
 */
export const getFullNewBlogPostBySlug = gql`
  ${FullNewBlogPostFragment}

  query GetFullNewBlogPostBySlug($slug: String!, $locale: String!, $preview: Boolean) {
    newBlogPostCollection(
      where: { slug: $slug }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...FullNewBlogPostFragment
      }
    }
  }
`;

/**
 * Get all NewBlogPost entries with pagination (base - scalars only)
 */
export const getBaseNewBlogPosts = gql`
  ${BaseNewBlogPostFragment}

  query GetBaseNewBlogPosts(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [NewBlogPostOrder]
    $where: NewBlogPostFilter
    $preview: Boolean
  ) {
    newBlogPostCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseNewBlogPostFragment
      }
    }
  }
`;

/**
 * Get all NewBlogPost entries with pagination (standard - 1 level deep)
 */
export const getNewBlogPosts = gql`
  ${NewBlogPostFragment}

  query GetNewBlogPosts(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [NewBlogPostOrder]
    $where: NewBlogPostFilter
    $preview: Boolean
  ) {
    newBlogPostCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...NewBlogPostFragment
      }
    }
  }
`;

/**
 * Get all NewBlogPost entries with pagination (full - 2 levels deep)
 */
export const getFullNewBlogPosts = gql`
  ${FullNewBlogPostFragment}

  query GetFullNewBlogPosts(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [NewBlogPostOrder]
    $where: NewBlogPostFilter
    $preview: Boolean
  ) {
    newBlogPostCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullNewBlogPostFragment
      }
    }
  }
`;
